"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H4V7c0-.55-.45-1-1-1"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-3.54 12.01-.63-1.82H12.2l-.65 1.82c-.1.29-.38.48-.68.48-.51 0-.86-.51-.68-.98l2.73-7.27c.16-.44.6-.74 1.08-.74s.92.3 1.09.75l2.73 7.27c.18.47-.17.98-.68.98-.31 0-.58-.19-.68-.49"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "m13.96 7.17-1.31 3.72h2.69l-1.3-3.72z"
}, "2")], 'TypeSpecimenRounded');